<div class="header-container">
  <div class="header">
    <div class="header-left">
      <dgx-components-icon
        class="message-bot-icon"
        name="message-bot"
        size="lg"
      ></dgx-components-icon>
      <h2 class="title">Smart-Fix support</h2>
    </div>
    <div class="beta-tag">BETA</div>
    <dgx-components-icon
      *ngIf="!isFeedback"
      (click)="onEndChat()"
      class="functionality-icon"
      name="close"
      size="lg"
    ></dgx-components-icon>
  </div>
</div>
